import { createStyles, makeStyles } from '@hawkins/styles';
export var COLLAPSE_ANIMATION_DURATION = 300;
export var COLLAPSE_ANIMATION_TIMING_FN = 'ease';
export function collapseStyles() {
    return createStyles({
        /** Class name of the root element. */
        root: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            // Animating height isn't ideal for performance
            // (see https://developer.chrome.com/blog/performant-expand-and-collapse/),
            // but using `transform: scaleY(...)` leaves a noticeable layout gap until the transformation is finished.
            //
            // TODO(style): Try to find a better solution (for ideas, see https://carlanderson.xyz/how-to-animate-on-height-auto/).
            transition: "height ".concat(COLLAPSE_ANIMATION_DURATION, "ms ").concat(COLLAPSE_ANIMATION_TIMING_FN),
        },
        /** Class name to apply to the component is shown */
        shown: {
            flexGrow: 1,
        },
        /** Class name to apply to the component is hidden */
        hidden: {
            flexGrow: 0,
            // This `height: 0` styling is important.
            // It provides a backup implementation in case our JS resizing code doesn't execute for some reason
            // (switching between the `hidden` and `shown` CSS classes changes the height from `0` to `auto`),
            // and it sets the initial height of a collapsed element to 0,
            // which is required for our JS resizing code to work properly.
            height: 0,
            // `visibility: hidden` prevents content from being focusable, so collapsed content can't be tabbed into.
            // It is also removed from the accessibility tree.
            visibility: 'hidden',
        },
        /** Class name to apply to the component when the animation is disabled */
        rootDisabledAnimation: {
            transition: 'none',
        },
    });
}
export var useCollapseStyles = makeStyles(collapseStyles(), { name: 'Hawkins-Collapse' });
